import { Params } from '@angular/router';
import { DashboardLink } from '@partner/feature-modules/dashboard/domain/model/dashboard-link.model';

/** A dashboard link on the wire: every query value is an array of strings. */
export interface DashboardLinkResponse {
  route: string;
  query: Record<string, string[]>;
}

/** Shaped as a reload parses the same URL: one value is a string, several stay an array, none is absent. */
export function adaptDashboardLink(link: DashboardLinkResponse): DashboardLink {
  const queryParams: Params = {};
  Object.entries(link.query ?? {}).forEach(([key, values]: [string, string[]]) => {
    if (values?.length === 1) {
      queryParams[key] = values[0];
    } else if (values?.length > 1) {
      queryParams[key] = [...values];
    }
  });
  return { route: link.route, queryParams };
}
